define(function (require, exports, module) {
    const toolkit = require('toolkit/b-toolkit/b-toolkit');
    const BToolkit = toolkit['b-toolkit'];
    const BDeepLinkBanner = require('blocks-cloud/b-deeplink-banner/b-deeplink-banner');
    const { createGaSender } = require('reactApp/utils/ga');

    const sendGaAb = createGaSender('pubfile');

    const BMobileShare = toolkit.create('b-mobile-share', {
        inner: true,

        init() {
            BToolkit.fn.init.apply(this, arguments);

            if (this.el) {
                this._init();
            }
        },

        onRender() {
            this._init();
        },

        _init() {
            this.initInner();

            this._$popup = this.$('__popup');
            this._$placeholder = this.$('__placeholder');
            this._$menu = this.$('__menu');
            this._$sharing = this.$('__sharing');

            this._$openShare = this.$('[data-name=open-share]');
            this._$closeShare = this.$('[data-name=close-share]');

            this._$openShare.add(this._$closeShare).on(
                'click',
                function (e) {
                    e.preventDefault();

                    sendGaAb('old', 'share-click');

                    if (this.data.isNativeShare) {
                        navigator
                            .share({
                                url: window.location.href,
                            })
                            .catch(() => {
                                sendGaAb('old', 'share-error');
                            });

                        return;
                    }

                    this._$menu.toggle();
                    this._$sharing.toggle();
                }.bind(this)
            );

            this._inAppBlock = this.$('.b-deeplink-banner').getBlock();
            this._$downloadBtn = this.$('.b-deeplink-banner>a');
        },

        show() {
            this._$popup.show();

            if (this._$downloadBtn.length) {
                sendGaAb('old', 'show', 'mobshare');

                this._$downloadBtn[0].addEventListener('click', () => sendGaAb('old', 'click', 'mobshare', true), true);
            }
        },

        setWide(state) {
            this._$popup.toggleMod('wide', state);
        },

        changeInAppUrl(url, params) {
            this.data.app_link = url;
            this.data.app_link_params = params;

            this._inAppBlock.render({
                app_link: url,
                app_link_params: params,
            });

            this._$downloadBtn = this.$('.b-deeplink-banner>a');
            if (this._$downloadBtn.length) {
                this._$downloadBtn[0].addEventListener('click', () => sendGaAb('old', 'click', 'mobshare', true), true);
            }
        },
    });

    module.exports = BMobileShare;
});
